module.exports = __webpack_public_path__ + "6db1e338667bb884cda15e6a625a16f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_8.jpg
// module id = 1756
// module chunks = 5